import { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import uiWebOne from "../../common/images/uiux-web-1.png";
import uiWebTwo from "../../common/images/uiux-web-2.png";
import uiWebThree from "../../common/images/uiux-web-3.png";
import uiWebFour from "../../common/images/uiux-web-4.png";
import uiWebFive from "../../common/images/uiux-web-5.png";
import uiWebSix from "../../common/images/uiux-web-6.png";
import uiWebSeven from "../../common/images/uiux-web-7.png";
import uiWebEight from "../../common/images/uiux-web-8.png";
import uiWebNine from "../../common/images/uiux-web-9.png";
import uiWebTen from "../../common/images/uiux-web-10.png";
import uiWebEleven from "../../common/images/uiux-web-11.png";
import uiWebTwelve from "../../common/images/uiux-web-12.png";
import uiWebThirteen from "../../common/images/uiux-web-13.png";
import uiWebFourteen from "../../common/images/uiux-web-14.png";
import uiWebFifteen from "../../common/images/uiux-web-15.png";
import uiWebSixteen from "../../common/images/uiux-web-16.png";


const PortfolioSlider = () => {
  const categories = {
    Web: [
      { img: uiWebOne, link: "https://www.airportparkingsolutions.com/" },
      { img: uiWebTwo, link: "https://www.smartparkingdeals.co.uk/" },
      { img: uiWebThree, link: "https://www.aygoparking.co.uk/" },
      { img: uiWebFour, link: "https://www.airportparkingsolutions.com/" },
      { img: uiWebFive, link: "https://www.italianpizzas.co.uk/" },
      { img: uiWebSix, link: "https://www.chikitosperiperi.co.uk/" },
    ],
    Android: [
      {
        img: uiWebSeven,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebEight,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebTen,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebEleven,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebTwelve,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebSixteen,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebFifteen,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebFourteen,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
      {
        img: uiWebThirteen,
        link: "https://play.google.com/store/apps/collection/cluster?gsr=SmNqGG1yOWxTUmx5Q2tvT1VpVHV4ZEVGR2c9PbICRgopCiVjb20uU21hcnRTd2l0Y2guU2hhcmVpdC5UcmFuc2ZlckZpbGVzEAcSFwgBEhM1NTcyNzMwMTIzMTc1NDk5NDAwGAA%3D:S:ANO1ljI6yEU",
      },
    ],
  };

  const [selectedCategory, setSelectedCategory] = useState("Web");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

 
  const portfolioItems = categories[selectedCategory];

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? portfolioItems.length - itemsPerPage : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + itemsPerPage >= portfolioItems.length ? 0 : prev + 1
    );
  };
  const backgroundImage = {
    backgroundImage: `url(/ui-back.png)`,
    backgroundSize: " 90%  90%",
    backgroundPosition: "top right",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div
      className="max-w-[1280px] mx-auto py-10 px-4 text-center relative"
      style={backgroundImage}
    >
      {/* Title */}
      <h2 className="small:text-5xl text-3xl font-bold text-black mb-2">
        Portfolio/Case Studies
      </h2>
      <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
        <p className="h-[5px] rounded-xl bg-webYellow w-[50%]"></p>
      </div>

      {/* Section Number & Category Selection */}
      <div className="flex items-center justify-between text-lg pb-2 mb-6 border-b-2 border-webYellow">
        <span className="font-bold text-black small:text-5xl text-3xl border-b-[3px] pb-4 border-black">
          {selectedCategory === "Web" ? "01." : "02."}
        </span>
        <div className="flex items-center gap-4">
          <button
            onClick={() => {
              setSelectedCategory("Web");
              setCurrentIndex(0);
            }}
            className={`px-1 py-2 text-md font-medium ${
              selectedCategory === "Web" ? "text-blue-600 " : "text-gray-600"
            }`}
          >
            Web
          </button>
          <span className="hidden small:inline text-gray-500">|</span>

          <button
            onClick={() => {
              setSelectedCategory("Android");
              setCurrentIndex(0);
            }}
            className={`px-1 py-2 text-md font-medium ${
              selectedCategory === "Android"
                ? "text-blue-600 "
                : "text-gray-600"
            }`}
          >
            Android
          </button>
        </div>
      </div>

      {/* Portfolio Image Grid */}
      <div className="flex justify-center gap-4 flex-wrap">
        {portfolioItems
          .slice(currentIndex, currentIndex + itemsPerPage)
          .map((item, index) => (
            <div
              key={index}
              className="relative w-[45%] sm:w-[250px] md:w-[300px] h-[200px] sm:h-[250px] md:h-[300px] overflow-hidden rounded-lg shadow-lg group"
            >
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={item.img}
                  alt="Portfolio item"
                  className="w-full h-full object-cover"
                />
                {/* Hover Overlay */}
                <div className="absolute inset-0 top-[20%]  left-[20%] bg-black rounded-full small:size-[50%] size-[100px]  bg-opacity-80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-white small:text-[16px] text-[12px]  font-semibold">
                    Click to View project
                  </span>
                </div>
              </a>
            </div>
          ))}
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-end mt-6 pr-10">
        <button
          onClick={prevSlide}
          className="p-3 bg-gray-300 rounded-md hover:bg-yellow-500 hover:text-white mr-4"
        >
          <FaArrowLeft size={20} />
        </button>
        <button
          onClick={nextSlide}
          className="p-3 bg-webYellow rounded-md hover:bg-yellow-500"
        >
          <FaArrowRight size={20} className="text-white" />
        </button>
      </div>
    </div>
  );
};

export default PortfolioSlider;
